import httpClient from "@/services/http/mainServerClient";

let cache: string[] = null;

function split(joinedKeywords: string): string[] {
  if (joinedKeywords) {
    return joinedKeywords
      .split("\n")
      .map(v => v.trim())
      .filter(v => !!v);
  }
  else {
    return [];
  }
}

async function get(): Promise<string[]> {
  const joinedKeywords = await httpClient.get(`/sku_properties_filter/get`).then((dto: any) => dto.keywords);
  cache = split(joinedKeywords);
  return cache;
}

async function getCache() {
  return cache ? cache : get();
}

async function save(keywords: string): Promise<void> {
  const data = { keywords };
  await httpClient.post(`/sku_properties_filter/save`, data).then((dto: any) => dto.successful);
  cache = split(keywords);
}

export default {
  get,
  getCache,
  save
};
